import { render, staticRenderFns } from "./Loader.vue?vue&type=template&id=59d3fac7&scoped=true&"
import script from "./Loader.ts?vue&type=script&lang=ts&"
export * from "./Loader.ts?vue&type=script&lang=ts&"
import style0 from "./Loader.scss?vue&type=style&index=0&id=59d3fac7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59d3fac7",
  null
  
)

export default component.exports